import { toast } from 'react-toastify';
import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';
import { setIsWaiting, setRemoveLoading, setShowRemovePopup, setShowPopup } from '../../../../actions/general';

import { getUserAdmin } from '../../../../helpers/system-admin';
import { DEFAULT_FN } from '../../../../constants';

export const SET_ADMIN_USER_DETAILS = 'setAdminUserDetails';
export const UPDATE_ADMIN_USER_DETAILS = 'updateAdminUserDetails';
export const UPDATE_ADMIN_USER = 'updateAdminUser';
export const DELETE_ADMIN_USER = 'deleteAdminUser';

export const API_SYSTEM_ADMIN_USER_DATA_LISTS = 'user/data-lists';
export const API_SYSTEM_ADMIN_USER = 'user';
export const API_SYSTEM_ADMIN_USER_DETAIL = 'user/:id';
export const API_SYSTEM_ADMIN_ADD_USER = 'user/create-user-admin';
export const API_SYSTEM_ADMIN_USER_LOGIN_AS = 'auth/login-as';

export const fetchAdminUserDataLists = (paginationPayload, nextDispatch) => () => {
     const { useInfiniteScroll, setUsers, setIsLoading = DEFAULT_FN } = nextDispatch;
     const { filter, page, pageSize, sortBy, sortType } = paginationPayload;
     const filterQuery = Object.keys(filter).length ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';

     callApi(`${API_SYSTEM_ADMIN_USER_DATA_LISTS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`, 'GET').then(
          (response) => {
               setIsLoading(false);

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const userResponse = response.data;

               if (useInfiniteScroll) {
                    setUsers((currentUser) => {
                         const newUsers = [...currentUser.rows, ...userResponse.rows];

                         return {
                              count: userResponse.count,
                              rows: newUsers,
                         };
                    });
               } else {
                    setUsers(userResponse);
               }
          }
     );
};

// Get User Details
export const setAdminUserDetails = (userDetails) => {
     return {
          type: SET_ADMIN_USER_DETAILS,
          payload: userDetails,
     };
};

export const fetchAdminUserDetailsRequest = (userId, nextDispatch) => (dispatch) => {
     const { setIsLoading = DEFAULT_FN, navigateUserNotFound = DEFAULT_FN } = nextDispatch || {};

     setIsLoading(true);
     callApi(API_SYSTEM_ADMIN_USER_DETAIL.replace(':id', userId), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    navigateUserNotFound();
                    return;
               }

               dispatch(setAdminUserDetails(getUserAdmin(response.data)));
          })
          .finally(() => {
               setIsLoading(false);
          });
};

// Update
export const updateAdminUser = (userId, user) => {
     return {
          type: UPDATE_ADMIN_USER,
          payload: {
               userId,
               user,
          },
     };
};

export const updateAdminUserDetails = (user) => {
     return {
          type: UPDATE_ADMIN_USER_DETAILS,
          payload: user,
     };
};

// Delete
export const deleteAdminUser = (userId) => {
     return {
          type: DELETE_ADMIN_USER,
          payload: userId,
     };
};

export const deleteAdminUserRequest =
     (userId, fetchUsers = DEFAULT_FN) =>
     (dispatch) => {
          dispatch(setRemoveLoading(true));
          callApi(API_SYSTEM_ADMIN_USER_DETAIL.replace(':id', userId), 'DELETE')
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    dispatch(deleteAdminUser(userId));

                    fetchUsers();
                    toast.success('Deleted successfully');
               })
               .finally(() => {
                    dispatch(setRemoveLoading(false));
                    dispatch(setShowRemovePopup(null));
               });
     };

export const addSystemAdminUserRequest = (payload, paginationPayload, setUsers) => (dispatch) => {
     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_ADD_USER, 'POST', payload)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newUser = response.data;
               newUser.highestAccess = 'Member';

               const userNextDispatch = {
                    setUsers,
               };

               dispatch(fetchAdminUserDataLists(paginationPayload, userNextDispatch));
               dispatch(setShowPopup());
               toast.success('Created successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};
